/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';
import validate from 'validate.js';
import {
  DialogDefaultV2,
  DateTimePickerV2,
  InputV2,
  InputFormatV2,
  DefaultSelectV2,
  ArquivoContainerV2,
  TrueFalseSelectV2,
  WidgetV2,
} from '../../../../components/v2';

import * as selectorsAuth from '../../../../store/auth/reducer';
import * as selectorsNsir from '../../../../store/nsir/reducer';
import * as selectorsNsmp from '../../../../store/nsmp/reducer';
import * as actionsNsmp from '../../../../store/nsmp/actions';
import * as Role from '../../../../constants/role';
import * as Status from '../../../../constants/status';
import { isInspecaoAnticorrocao, isInspecaoTermografica, isInspecaoMtBt } from 'utils';
import {
  podeChamarPatchAuditoria,
  situacaoPermiteEdicaoAuditoria,
} from '../../../../helpers/auditoriaNsirPermission';

const rootGridSx = { pt: 1 };
const fieldContainerSx = { pb: 0 };
const widgetContentSx = { p: '10px', bgcolor: 'background.paper' };
const requiredTextSx = { color: 'error.main', pt: 0.5 };

const NsmpModal = ({
  open,
  onCancel,
  onConfirm,
  onConfirmAndNext,
  selectedId,
  nsmps,
  nsmpSelected,
  loadNsmpById,
  readOnly,
  userRole,
  nsirStatus,
  nsirData,
  nsirTitle,
  isInspecaoFibraOptica,
  onNext,
  onPrevious,
  hasNext,
  hasPrevious,
  carouselPosition,
  patchNsmpAuditoria,
}) => {
  const [canEditNsmp, setCanEditNsmp] = useState(false);
  const [readOnlyLocal, setReadOnlyLocal] = useState(readOnly);
  const [modoEdicaoAuditoria, setModoEdicaoAuditoria] = useState(false);
  const [editFiles, setEditFiles] = useState(false);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({
    dataFotoDrone: moment().valueOf(),
    fotos: [],
  });

  useEffect(() => {
    setReadOnlyLocal(readOnly);
  }, [readOnly]);

  useEffect(() => {
    if (!open) {
      setModoEdicaoAuditoria(false);
    }
  }, [open]);

  const nsirStatusParaAuditoria = nsirData.status || nsirStatus;

  useEffect(() => {
    if (!situacaoPermiteEdicaoAuditoria(nsirStatusParaAuditoria)) {
      setModoEdicaoAuditoria(false);
    }
  }, [nsirStatusParaAuditoria]);

  useEffect(() => {
    if (selectedId) loadNsmpById(selectedId);
  }, [selectedId, loadNsmpById]);

  useEffect(() => {
    if (nsmpSelected && nsmpSelected.id) {
      setValues(nsmpSelected);
    }
  }, [nsmpSelected]);

  const setSchema = fields => {
    let schema = {};
    fields.forEach(f => {
      schema = {
        ...schema,
        [f]: {
          presence: { allowEmpty: false, message: 'é obrigatório' },
        },
      };
    });
    return schema;
  };

  const validateCoordenadas = data => {
    let localErrors = {};

    if (nsirStatus === Status.EM_DIGITACAO) {
      if (data.tipoServico === 'NC') {
        return localErrors;
      }

      if (data.latitude && (data.latitude.trim().length !== 9 || !data.latitude.match(/\d{2}(,\d{6})?/))) {
        localErrors = { ...localErrors, latitude: ['O Campo é inválido'] };
      }

      if (data.longitude && (data.longitude.trim().length !== 9 || !data.longitude.match(/\d{2}(,\d{6})?/))) {
        localErrors = { ...localErrors, longitude: ['O Campo é inválido'] };
      }

      if (data.coordenada && (data.coordenada.trim().length !== 14 || !data.coordenada.match(/\d{5}(:\d{7})?/))) {
        localErrors = { ...localErrors, coordenada: ['O Campo é inválido'] };
      }

      if ((!data.latitude || !data.longitude) && !data.coordenada) {
        localErrors = {
          ...localErrors,
          latitude: ['O Campo é obrigatório'],
          longitude: ['O Campo é obrigatório'],
          coordenada: ['O Campo é obrigatório'],
        };
      }
    }

    return localErrors;
  };

  const getSchema = () => {
    let schema = ['prioridade', 'acesso', 'servico', 'acessoVeiculo', 'equipeIndicada', 'fotos'];

    if (nsirData.area === 'RDU') {
      schema.push('endereco');
    }

    if (nsirStatus === Status.EM_DIGITACAO) {
      schema = ['tipoServico'];
      if (values.tipoServico === 'PL') {
        schema.push('numLinhasPlanilha');
      } else if (values.tipoServico === 'PR') {
        schema.push('nsmpProgramada');
      } else if (values.tipoServico === 'FO') {
        schema.push('quantidadePostes');
      }

      if (values.tipoServico === 'NC') {
        schema.push('motivo');
      } else if (values.tipoServico !== 'NC' && values.tipoServico !== 'PR' && values.tipoServico !== 'AT') {
        schema.push('nsmp');
      }
    }

    return setSchema(schema);
  };

  const handleChange = (id, value) => {
    setValues({
      ...values,
      [id]: value,
    });
  };

  const clearForm = () => {
    setCanEditNsmp(false);
    setEditFiles(false);
    setModoEdicaoAuditoria(false);
    setErrors({});
    setValues({
      fotos: [],
      dataFotoDrone: moment().valueOf(),
    });
  };

  const revertToViewMode = () => {
    setCanEditNsmp(false);
    setModoEdicaoAuditoria(false);
    setEditFiles(false);
    setErrors({});
    setReadOnlyLocal(true);
    if (nsmpSelected && nsmpSelected.id) {
      setValues(nsmpSelected);
    }
  };

  const onCancelLocal = () => {
    if (canEditNsmp || modoEdicaoAuditoria) {
      revertToViewMode();
      return;
    }
    clearForm();
    onCancel();
  };

  const getDataFotoDrone = () => {
    let data = moment().valueOf();

    if (values.dataFotoDrone) {
      data = values.dataFotoDrone;
    }

    return moment(data).valueOf();
  };

  const buildPayload = () => {
    const payload = {
      ...values,
      codigo: getCodigo(),
      dataFotoDrone: getDataFotoDrone(),
      updateFiles: editFiles,
    };
    delete payload.auditoria;
    delete payload.auditoriaDescription;
    return payload;
  };

  const runValidation = () => {
    let validationErrors = { ...validate(values, getSchema()) };
    if (!isInspecaoFibraOptica && nsirStatus === Status.EM_DIGITACAO) {
      validationErrors = { ...validationErrors, ...validateCoordenadas(values) };
    }
    setErrors(validationErrors);
    return !validationErrors || Object.keys(validationErrors).length === 0;
  };

  const onConfirmLocal = () => {
    if (modoEdicaoAuditoria && values.id && !canEditNsmp) {
      const aud = values.auditoria === true ? true : values.auditoria === false ? false : null;
      if (aud === null) {
        setErrors({ ...errors, auditoria: ['é obrigatório'] });
        return;
      }
      patchNsmpAuditoria(
        {
          nsmpId: values.id,
          auditoria: aud,
          auditoriaDescription: values.auditoriaDescription ?? '',
        },
        () => {
          setModoEdicaoAuditoria(false);
          setReadOnlyLocal(readOnly);
        }
      );
      return;
    }
    if (runValidation()) {
      const payload = buildPayload();
      clearForm();
      onConfirm(payload);
    }
  };

  const onConfirmAndNextLocal = () => {
    if (modoEdicaoAuditoria && values.id && !canEditNsmp) {
      onConfirmLocal();
      return;
    }
    if (runValidation()) {
      const payload = buildPayload();
      clearForm();
      onConfirmAndNext(payload);
    }
  };

  const getCodigo = () => {
    if (values && values.id) return values.codigo;

    let codigo = Array.isArray(nsmps) && nsmps.length > 0
      ? nsmps.filter(n => n.fotoInicio !== true && n.fotoFim !== true && n.analiseRisco !== true).length + 1
      : 1;
    while ((codigo + '').length < 3) codigo = `0${codigo}`;
    return codigo;
  };

  const isAdmin = () => userRole === Role.ADMIN || userRole === Role.SUPER_ADMIN;

  const getTitle = () => {
    if (userRole === Role.INSPETOR && !selectedId) {
      return `${nsirTitle} > Novo Serviço ${values.codigo}`;
    }
    if (values.nsmp) {
      return `${nsirTitle} > Serviço ${values.codigo} > NSMP ${values.nsmp}`;
    }
    return `${nsirTitle} > Serviço ${values.codigo}`;
  };

  const podeUsarBotaoAuditar = () =>
    values.id &&
    nsirData.id &&
    isInspecaoMtBt(nsirData.tipoServicoId) &&
    situacaoPermiteEdicaoAuditoria(nsirStatusParaAuditoria) &&
    podeChamarPatchAuditoria(userRole) &&
    readOnlyLocal &&
    !canEditNsmp;

  const bloquearCamposAuditoriaNsmp = () =>
    !modoEdicaoAuditoria ||
    !situacaoPermiteEdicaoAuditoria(nsirStatusParaAuditoria) ||
    !podeChamarPatchAuditoria(userRole);

  const tipoServicoOptions = () => {
    const isTermografica = isInspecaoTermografica(nsirData.tipoServicoId, nsirData.subtipoId);
    return [
      ...(isTermografica ? [{ id: 'AT', nome: 'Análise Termográfica' }] : []),
      ...[
        { id: 'E', nome: 'E-mail' },
        { id: 'EM', nome: 'Emergência' },
        { id: 'L', nome: 'Limpeza de Faixa' },
        { id: 'M', nome: 'Manutenção' },
        { id: 'NC', nome: 'Não Cadastrada' },
        { id: 'OB', nome: 'Objeto na Rede' },
        { id: 'OS', nome: 'OSAF' },
        { id: 'PL', nome: 'Planilha' },
        { id: 'P', nome: 'Poda RDR ou RDU' },
        { id: 'PR', nome: 'Programada' },
      ],
      ...(isTermografica ? [{ id: 'RT', nome: 'Relatório Termográfico' }] : []),
    ];
  };

  const buildHeaderActions = () => {
    const actions = [];
    if (carouselPosition) {
      actions.push({ title: '◄', onClick: onPrevious, disabled: !hasPrevious });
      actions.push({ title: `${carouselPosition.current} / ${carouselPosition.total}`, onClick: () => {}, disabled: true });
      actions.push({ title: '►', onClick: onNext, disabled: !hasNext });
    }

    if (isAdmin() && readOnlyLocal) {
      actions.push({ onClick: () => { setReadOnlyLocal(false); setCanEditNsmp(true); }, title: 'Editar' });
    }

    if (podeUsarBotaoAuditar()) {
      actions.push({
        title: 'Auditar',
        onClick: () => setModoEdicaoAuditoria(true),
      });
    }

    return actions.length > 0 ? actions : null;
  };

  const isReadOnly =
    canEditNsmp
      ? false
      : modoEdicaoAuditoria
        ? false
        : nsirStatus === Status.EM_DIGITACAO
          ? false
          : readOnlyLocal;

  const extraActions = hasNext && !isReadOnly && canEditNsmp
    ? [{ label: 'Salvar e Avançar', onClick: onConfirmAndNextLocal }]
    : null;

  const showAuditoria =
    values.id &&
    nsirData.id &&
    isInspecaoMtBt(nsirData.tipoServicoId) &&
    podeChamarPatchAuditoria(userRole) &&
    situacaoPermiteEdicaoAuditoria(nsirStatusParaAuditoria);

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCancelLocal}
      handlerConfirm={onConfirmLocal}
      title={getTitle()}
      confirmMessage="Salvar"
      fullScreen
      readOnly={isReadOnly}
      headerAction={buildHeaderActions()}
      extraActions={extraActions}
    >
      <Grid container spacing={1} sx={rootGridSx}>
        <>
          <Grid size={{ xs: 12, sm: 1 }} sx={fieldContainerSx}>
            <InputV2 name="codigo" label="Código" disabled value={getCodigo()} />
          </Grid>
          <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
            <DateTimePickerV2
              onChange={data => handleChange('dataFotoDrone', data.valueOf())}
              label="Data da Foto Drone"
              value={values.dataFotoDrone || moment().valueOf()}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
            <DateTimePickerV2
              onChange={data => handleChange('dataFotoDroneFim', data.valueOf())}
              label="Data da Foto Drone Fim"
              value={nsirStatus === Status.EM_INSPECAO && !values.dataFotoDroneFim ? moment().valueOf() : values.dataFotoDroneFim}
              disabled={readOnlyLocal || values.equipeIndicada !== 'FAIXA'}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 1 }} sx={fieldContainerSx}>
            <DefaultSelectV2
              error={!!(errors && errors.prioridade)}
              isRequired
              label="Prioridade"
              name="prioridade"
              showEmpty
              options={[
                { id: 'E', nome: 'E' },
                { id: '1', nome: '1' },
                { id: '2', nome: '2' },
                { id: '3', nome: '3' },
                { id: '4', nome: '4' },
              ]}
              onSelect={event => handleChange(event.target.name, event.target.value)}
              value={values.prioridade}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
            <DefaultSelectV2
              error={!!(errors && errors.acesso)}
              isRequired
              label="Acesso"
              name="acesso"
              showEmpty
              options={[
                { id: 'FACIL', nome: 'Fácil' },
                { id: 'MEDIO', nome: 'Médio' },
                { id: 'DIFICIL', nome: 'Difícil' },
              ]}
              onSelect={event => handleChange(event.target.name, event.target.value)}
              value={values.acesso}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
            <DefaultSelectV2
              error={!!(errors && errors.acessoVeiculo)}
              isRequired
              label="Acesso Veiculo"
              name="acessoVeiculo"
              showEmpty
              options={[
                { id: 'true', nome: 'Sim' },
                { id: 'false', nome: 'Não' },
              ]}
              onSelect={event => handleChange(event.target.name, event.target.value)}
              value={values.acessoVeiculo}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
            <DefaultSelectV2
              error={!!(errors && errors.equipeIndicada)}
              isRequired
              label="Equipe Indicada"
              name="equipeIndicada"
              showEmpty
              options={[
                { id: 'DUPLA', nome: 'Dupla' },
                { id: 'TRIO', nome: 'Trio' },
                { id: 'PESADA', nome: 'Pesada' },
                { id: 'LINHA_VIVA', nome: 'Linha Viva' },
                { id: 'PODA', nome: 'Poda' },
                { id: 'FAIXA', nome: 'Faixa' },
              ]}
              onSelect={event => handleChange(event.target.name, event.target.value)}
              value={values.equipeIndicada}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12 }} sx={fieldContainerSx}>
            <InputV2
              error={!!(errors && errors.endereco && nsirData.area === 'RDU')}
              isRequired={nsirData.area === 'RDU'}
              label="Endereço"
              name="endereco"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.endereco}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12 }} sx={fieldContainerSx}>
            <InputV2
              error={!!(errors && errors.servico)}
              isRequired
              multiline
              rows={2}
              label="Serviço"
              name="servico"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.servico}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <InputV2
              label="Número do Poste"
              name="numeroPoste"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.numeroPoste}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <DefaultSelectV2
              label="Altura do Poste"
              name="alturaPoste"
              showEmpty
              options={[
                { id: '9 m', nome: '9 m' },
                { id: '10 m', nome: '10 m' },
                { id: '11 m', nome: '11 m' },
                { id: '12 m', nome: '12 m' },
                { id: '13 m', nome: '13 m' },
                { id: '15 m', nome: '15 m' },
                { id: '16 m', nome: '16 m' },
                { id: '17 m', nome: '17 m' },
              ]}
              onSelect={event => handleChange(event.target.name, event.target.value)}
              value={values.alturaPoste}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <DefaultSelectV2
              label="Capacidade do Poste"
              name="capacidadePoste"
              showEmpty
              options={[
                { id: '150 daN', nome: '150 daN' },
                { id: '300 daN', nome: '300 daN' },
                { id: '600 daN', nome: '600 daN' },
                { id: '1000 daN', nome: '1000 daN' },
              ]}
              onSelect={event => handleChange(event.target.name, event.target.value)}
              value={values.capacidadePoste}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <DefaultSelectV2
              label="Tipo do Poste"
              name="tipoPoste"
              showEmpty
              options={[
                { id: 'CC', nome: 'CC' },
                { id: 'DT', nome: 'DT' },
                { id: 'MD', nome: 'MD' },
                { id: 'OUTROS', nome: 'OUTROS' },
              ]}
              onSelect={event => handleChange(event.target.name, event.target.value)}
              value={values.tipoPoste}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <InputV2
              label="Estrutura BT"
              name="estruturaBt"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.estruturaBt}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <InputV2
              label="Cabo BT"
              name="caboBt"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.caboBt}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <InputV2
              label="Estrutura MT"
              name="estruturaMt"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.estruturaMt}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
            <InputV2
              label="Cabo MT"
              name="caboMt"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.caboMt}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid size={{ xs: 12 }} sx={fieldContainerSx}>
            <InputV2
              label="Observação (outras informações)"
              name="observacao"
              onChange={event => handleChange(event.target.name, event.target.value)}
              multiline
              rows={2}
              value={values.observacao}
              disabled={readOnlyLocal}
            />
          </Grid>
        </>
        {(Role.DIGITADOR === userRole || Role.ADMIN === userRole) && nsirStatus !== Status.EM_INSPECAO && (
          <Grid size={{ xs: 12 }}>
            <WidgetV2 title="Informações da NSMP">
              <Box sx={widgetContentSx}>
                <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
              <DefaultSelectV2
                error={!!(errors && errors.tipoServico)}
                isRequired={isAdmin() ? false : nsirStatus === Status.EM_DIGITACAO}
                label="Tipo de Serviço"
                name="tipoServico"
                showEmpty
                options={tipoServicoOptions()}
                onSelect={event => {
                  setValues({
                    ...values,
                    [event.target.name]: event.target.value || null,
                    numLinhasPlanilha: null,
                    motivo: null,
                    nsmp: event.target.value === 'E' ? 'E-MAIL' : event.target.value === 'EM' ? 'EMERGÊNCIA' : event.target.value === 'OS' ? 'OSAF' : '',
                  });
                }}
                value={values.tipoServico}
                disabled={canEditNsmp ? false : nsirStatus !== Status.EM_DIGITACAO}
              />
            </Grid>
            {!isInspecaoFibraOptica && <>
              <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
                <DefaultSelectV2
                  error={!!(errors && errors.motivo)}
                  isRequired={nsirStatus === Status.EM_DIGITACAO && values.tipoServico === 'NC'}
                  label="Motivo"
                  name="motivo"
                  showEmpty
                  options={[
                    { id: 'NCA', nome: 'Anotação Indevida' },
                    { id: 'NCD', nome: 'Duplicidade' },
                    { id: 'NCP', nome: 'Prioridade' },
                    { id: 'NCPL', nome: 'Planilha' },
                  ]}
                  onSelect={event => {
                    setValues({
                      ...values,
                      [event.target.name]: event.target.value || null,
                    });
                  }}
                  value={values.motivo}
                  disabled={canEditNsmp ? values.tipoServico !== 'NC' : nsirStatus !== Status.EM_DIGITACAO || (nsirStatus === Status.EM_DIGITACAO && values.tipoServico !== 'NC')}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
                <InputV2
                  error={!!(errors && errors.numLinhasPlanilha)}
                  isRequired={values.tipoServico === 'PL'}
                  name="numLinhasPlanilha"
                  label="N° Linhas"
                  value={values.numLinhasPlanilha}
                  onChange={event => handleChange(event.target.name, event.target.value)}
                  disabled={canEditNsmp ? values.tipoServico !== 'PL' : (nsirStatus !== Status.EM_DIGITACAO || (nsirStatus === Status.EM_DIGITACAO && values.tipoServico !== 'PL'))}
                />
              </Grid>
            </>}
            {!!isInspecaoFibraOptica && (
              <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
                <InputV2
                  error={!!(errors && errors.quantidadePostes)}
                  isRequired={values.tipoServico === 'FO'}
                  name="quantidadePostes"
                  label="Quantidade de Postes"
                  value={values.quantidadePostes}
                  onChange={event => handleChange(event.target.name, event.target.value)}
                  disabled={canEditNsmp ? values.tipoServico !== 'FO' : (nsirStatus !== Status.EM_DIGITACAO || (nsirStatus === Status.EM_DIGITACAO && values.tipoServico !== 'FO'))}
                />
              </Grid>
            )}
            <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
              <InputV2
                error={!!(errors && errors.nsmpProgramada)}
                isRequired={values.tipoServico === 'PR'}
                name="nsmpProgramada"
                label="N° Nsmp Programada"
                value={values.nsmpProgramada}
                onChange={event => handleChange(event.target.name, event.target.value)}
                disabled={canEditNsmp ? false : nsirStatus !== Status.EM_DIGITACAO}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
              <InputV2
                error={!!(errors && errors.nsmp)}
                isRequired={nsirStatus === Status.EM_DIGITACAO && values.tipoServico !== 'NC' && values.tipoServico !== 'PR' && values.tipoServico !== 'AT'}
                name="nsmp"
                label="N° Nsmp Nova"
                value={values.nsmp}
                onChange={event => handleChange(event.target.name, event.target.value)}
                disabled={canEditNsmp ? ['E', 'OS', 'PR'].includes(values.tipoServico) : (nsirStatus !== Status.EM_DIGITACAO || ['E', 'EM', 'OS', 'PR'].includes(values.tipoServico))}
              />
            </Grid>
            {!isInspecaoFibraOptica && <>
              <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
                <InputFormatV2
                  error={!!(errors && errors.latitude)}
                  helperText={errors && values.latitude ? 'O campo é inválido' : 'Latitude e Longidute ou Coordenada deve ser preenchido'}
                  name="latitude"
                  label="Latitude"
                  value={values.latitude}
                  onChange={event => handleChange(event.target.name, event.target.value)}
                  disabled={canEditNsmp ? false : nsirStatus !== Status.EM_DIGITACAO}
                  format="##,######"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
                <InputFormatV2
                  error={!!(errors && errors.longitude)}
                  helperText={errors && values.longitude ? 'O campo é inválido' : 'Latitude e Longidute ou Coordenada deve ser preenchido'}
                  name="longitude"
                  label="Longitude"
                  value={values.longitude}
                  onChange={event => handleChange(event.target.name, event.target.value)}
                  disabled={canEditNsmp ? false : nsirStatus !== Status.EM_DIGITACAO}
                  format="##,######"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }} sx={fieldContainerSx}>
                <InputFormatV2
                  error={!!(errors && errors.coordenada)}
                  helperText={errors && values.coordenada ? 'O campo é inválido' : 'Latitude e Longidute ou Coordenada deve ser preenchido'}
                  name="coordenada"
                  label="Absoluta N"
                  value={values.coordenada}
                  onChange={event => handleChange(event.target.name, event.target.value)}
                  disabled={canEditNsmp ? false : nsirStatus !== Status.EM_DIGITACAO}
                  format="######:#######"
                />
              </Grid>
            </>}
            <Grid size={{ xs: 12 }} sx={fieldContainerSx}>
              <InputV2
                label="Observação do Digitador (outras informações)"
                name="observacaoDigitador"
                onChange={event => handleChange(event.target.name, event.target.value)}
                multiline
                rows={3}
                value={values.observacaoDigitador}
                disabled={canEditNsmp ? false : nsirStatus !== Status.EM_DIGITACAO}
              />
            </Grid>
                </Grid>
              </Box>
            </WidgetV2>
          </Grid>
        )}
        {showAuditoria && (
          <Grid size={{ xs: 12 }}>
            <WidgetV2 title="Informações Auditoria">
              <Box sx={widgetContentSx}>
                <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
              <TrueFalseSelectV2
                label="Auditoria"
                name="auditoria"
                showEmpty
                disabled={bloquearCamposAuditoriaNsmp()}
                value={values.auditoria === true ? 'true' : values.auditoria === false ? 'false' : ''}
                onChange={event => {
                  const raw = event.target.value;
                  const auditoriaBool = raw === 'true' ? true : raw === 'false' ? false : null;
                  setValues({ ...values, auditoria: auditoriaBool });
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
              <InputV2 label="Auditado por" name="auditadoPor" value={values.auditadoPor} disabled />
            </Grid>
            <Grid size={{ xs: 12, sm: 2 }} sx={fieldContainerSx}>
              <InputV2 label="Auditado em" name="auditadoEm" value={values.auditadoEm} disabled />
            </Grid>
            <Grid size={{ xs: 12 }} sx={fieldContainerSx}>
              <InputV2
                label="Descrição da auditoria"
                name="auditoriaDescription"
                onChange={event => handleChange(event.target.name, event.target.value)}
                multiline
                rows={2}
                value={values.auditoriaDescription || ''}
                disabled={bloquearCamposAuditoriaNsmp()}
              />
            </Grid>
                </Grid>
              </Box>
            </WidgetV2>
          </Grid>
        )}
        <ArquivoContainerV2
          arquivos={values.fotos}
          showDescription={isInspecaoAnticorrocao(nsirData.tipoServicoId)}
          onSave={fotos => {
            setEditFiles(true);
            setValues({ ...values, fotos });
          }}
          disabled={canEditNsmp ? false : readOnlyLocal}
        />
        <Grid size={{ xs: 12 }} sx={fieldContainerSx}>
          {errors && errors.fotos && (
            <Typography sx={requiredTextSx}>*Imagens são obrigatórias</Typography>
          )}
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

NsmpModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onConfirmAndNext: PropTypes.func,
  open: PropTypes.bool.isRequired,
  selectedId: PropTypes.string,
  nsmps: PropTypes.array.isRequired,
  nsmpSelected: PropTypes.object.isRequired,
  loadNsmpById: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  nsirData: PropTypes.object.isRequired,
  nsirTitle: PropTypes.string.isRequired,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  hasNext: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  carouselPosition: PropTypes.object,
  patchNsmpAuditoria: PropTypes.func.isRequired,
};

NsmpModal.defaultProps = {
  selectedId: undefined,
};

const mapStateToProps = state => ({
  nsmps: selectorsNsmp.getNsmps(state),
  nsmpSelected: selectorsNsmp.getNsmpSelected(state),
  userRole: selectorsAuth.getRole(state),
  nsirStatus: selectorsNsir.getNsirStatus(state),
  nsirData: selectorsNsir.getNsirSelected(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsmp,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NsmpModal);
